'use strict'


import axios from 'axios'
import qs from 'qs'
import Base64 from 'base64-js'


import store from '../../store/index'


function str2ByteArr(str){
    var bytes = new Array();
    var len,c;
    len = str.length;
    for(var i = 0; i < len; i++){
        c = str.charCodeAt(i);
        if(c >= 0x010000 && c <= 0x10FFFF){
            bytes.push(((c >> 18) & 0x07) | 0xF0);
            bytes.push(((c >> 12) & 0x3F) | 0x80);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        }else if(c >= 0x000800 && c <= 0x00FFFF){
            bytes.push(((c >> 12) & 0x0F) | 0xE0);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        }else if(c >= 0x000080 && c <= 0x0007FF){
            bytes.push(((c >> 6) & 0x1F) | 0xC0);
            bytes.push((c & 0x3F) | 0x80);
        }else{
            bytes.push(c & 0xFF);
        }
    }
    return bytes;
}


axios.interceptors.request.use(config => {
    //store.commit('UPDATE_LOADING',true) //显示loading
    return config
}, error => {
    return Promise.reject(error)
})


axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error.response)
})

function errorState(response, resolve, reject) {
    reject(response)
    //store.commit('UPDATE_LOADING',false)  //隐藏loading
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        reject(response)
        return response
        // 如果不需要除了data之外的数据，可以直接 return response.data
    }else{
        alert("网络异常")
    }

}

function successState(res, resolve, reject) {
    //store.commit('UPDATE_LOADING',false) //隐藏loading
    //统一判断后端返回的错误码
    resolve(res.data)
}
const httpServer = (opts, data, header) => {
    let Public = { //公共参数
        //'srAppid': ""
    }
    let httpDefaultOpts = { //http默认配置
        method:opts.method,
        baseURL:opts.url,
        url: "",
        timeout: 10000,
        params:Object.assign(Public, data),
        //data:qs.stringify(Object.assign(Public, data)),
        data:data,
        headers: opts.method=='get'?{
            // 'Authorization': 'Basic ' +   Base64.fromByteArray(str2ByteArr("HagkCloudAdmin:Cl0ud@2o17"))
            // 'X-Requested-With': 'XMLHttpRequest',
            // "Accept": "application/json",
            // "Content-Type": "application/json; charset=UTF-8"
        }:(header?header:{
            //'X-Requested-With': 'XMLHttpRequest',
            //'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Content-Type': 'application/json; charset=UTF-8'
        }),
        transformRequest: [function (data) {
            // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
            return JSON.stringify(data);
            // if(opts.method=='post' && header && header['Content-Type'] && header['Content-Type'].indexOf('application/json') >= 0) {
            //     return JSON.stringify(data);
            // }
            // return qs.stringify(Object.assign(Public, data));
        }],
        paramsSerializer: function(params) {
            return qs.stringify(params, {arrayFormat: 'brackets'})
        },
    }


    if(opts.method=='get'){
        delete httpDefaultOpts.data
    }else{
        delete httpDefaultOpts.params
    }

    let promise = new Promise(function(resolve, reject) {
        axios(httpDefaultOpts).then(
            (res) => {
                successState(res, resolve, reject)
            }
        ).catch(
            (response) => {
                errorState(response, resolve, reject)
            }
        )
    })
    return promise
}

export default httpServer


// WEBPACK FOOTER //
// ./src/js/common/http.js